/**
 * Alert Message Component
 * Reusable alert component for success/error/info messages
 */

import React from "react";
import { Alert, Box } from "@mui/material";

const AlertMessage = ({
  severity = "info",
  title,
  message,
  sx = {},
  onClose,
  ...props
}) => {
  return (
    <Box sx={{ mb: 2, ...sx }}>
      <Alert severity={severity} onClose={onClose} {...props}>
        {title && (
          <Box component="strong" sx={{ display: "block", mb: 1 }}>
            {title}
          </Box>
        )}
        {message}
      </Alert>
    </Box>
  );
};

export default AlertMessage;
